import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ErrorComponent } from './error/error.component';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LoginComponent
  },
  {
    path: 'autologin',
    component: AutoLoginComponent
  },
  {
    path: 'admin-login',
    component: AdminLoginComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '**',
    redirectTo: 'oAuth/error'
  },
];


@NgModule({
  declarations: [LoginComponent, AutoLoginComponent, AdminLoginComponent],
  imports: [CommonModule, FormsModule, RouterModule.forChild(routes), OAuthModule.forRoot()
  ],
  providers: [
    { provide: OAuthStorage, useValue: localStorage },
  ],
  bootstrap: []
})
export class OauthModule {}